export interface CaseMessageResult {
  accepted: boolean;
}

/** Posts to a case's Messages tab, the same thread the Hub's case chat shows and the design team reads. */
export interface CaseMessageService {
  post(caseId: string, text: string): Promise<CaseMessageResult>;
}

/** Used where posting is not wired (tests, defaults): every post reports as failed, so Evie links the tab instead. */
export const noopCaseMessageService: CaseMessageService = {
  async post() {
    return { accepted: false };
  },
};
